"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownMenuState = void 0;
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _compoundComponents = require("@clds/compound-components");
var _useResetSelectionOnOpen = require("./useResetSelectionOnOpen");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useDropdownMenuState = (props, menuState) => {
  const [isOpened, setOpened] = (0, _reactUseControlledState.default)(props.defaultOpened, props.isOpened, props.onOpenedChange);
  const select = (id, autoClose) => {
    menuState.select(id);
    if (id === _compoundComponents.unselect || autoClose) {
      setOpened(false);
    }
  };
  (0, _useResetSelectionOnOpen.useResetSelectionOnOpen)(isOpened, menuState.selectedId, menuState.setFocusedId);
  return {
    isOpened,
    setOpened,
    ...menuState,
    select // select has to override menu state select prop!
  };
};
exports.useDropdownMenuState = useDropdownMenuState;
//# sourceMappingURL=useDropdownMenuState.js.map